export const audits = {
	navTitle: "Auditoria",
	filters: {
		employeePlaceholder: "Filtrar por funcionário",
		typePlaceholder: "Filtrar por tipo",
		functionPlaceholder: "Filtrar por função",
	},
	table: {
		columns: {
			date: "Data",
			employee: "Funcionário",
			place: "Estabelecimento",
			organization: "Organização",
			type: "Tipo",
			function: "Função",
			observation: "Observação",
			params: "Parâmetros",
			createdAt: "Criado em",
		},
		viewParams: "Visualizar",
		paramsModalTitle: "Parâmetros",
		exportFilename: "Auditorias",
		exportTitle: "Relatório de Auditorias",
	},
};
